<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 10px; line-height: 50px;border-bottom: 1px solid #ddd;">
            系统参数
        </div>
        <div style="padding: 20px;">

            <div>
                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table
                            :data="tableData"
                            :height="th"
                            border
                            style="width: 100%;">

                        <el-table-column
                                prop="datasourceUrl"
                                label="数据库地址" >
                        </el-table-column>

                        <el-table-column
                                prop="datasourceUsername"
                                label="数据库用户名" >
                        </el-table-column>

                        <el-table-column
                                prop="datasourcePassword"
                                label="数据库密码" >
                        </el-table-column>

                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>

    </div>
</template>

<script>
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    export default {
        name: "Page",

        data(){
            return{
                tableData:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                param:[],
                datasourcePassword:'',
                datasourceUrl:'',
                datasourceUsername:''
            }
        },
        created(){
            this.getList();
            this.th = this.$store.state.tableHeight;
        },
        components:{
        },
        watch: {

            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },

        },
        methods:{

            getList(){

                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+'Staff/GetSysParam',
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }

                }).then( (response)=> {
                    this.param.push(response.data.data)

                    if(response.data.error == 0){
                        console.log(this.param)
                        this.tableData = this.param;
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },

        }
    }
</script>

<style scoped>

</style>